import React, {useEffect, useState} from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Link,
  IconButton
} from '@material-ui/core/';

import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
//icons
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import fetchAPI from "../../../../components/utils/fetchAPI";
import Row from "./Row"
//styles
import { withStyles } from "@material-ui/core/styles";
import { Skeleton } from '@material-ui/lab';
import { Box, Collapse } from '@mui/material';
import runtimeEnv from "@mars/heroku-js-runtime-env";
import { MsalContext } from "@azure/msal-react";
import DialogHoneyLoad from '../DialogHoneyLoad/DialogHoneyLoad';

const env = runtimeEnv();
export default function DataTable(props) {
  const {
    StyledTableCell,
    head,
    classStyle,
    body,
    StyledTableRow,
    dateStart,
    dateEnd,
    page,
    rowsPerPage,
    selectedCountryCode,
    todoModal,
    funtionDateFormat,
    totalColumsConsol,
    countryCode,
    showModalParts,
  } = props;

  return (
    <TableContainer
      component={Paper}
      classes={classStyle}
    >
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            {head.map((element, key) => (
              <StyledTableCell align="left" key={key}>
                {element} {element === "Usuario" || element === "Estatus" ? <img style={{ marginLeft: "2rem" }} src="assets/filter/filter.png" alt="" /> : null}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {body.length > 0 ? (
            body
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <Row key={row.name} row={row} showModalParts={showModalParts} funtionDateFormat={funtionDateFormat} todoModal={todoModal} selectedCountryCode={selectedCountryCode} countryCode={countryCode} />
              ))
          ) : (new Date(dateEnd).getDate() === new Date(dateStart).getDate() ||  new Date(dateEnd).getDate() === new Date(dateStart).getDate()+1) ? (
            <StyledTableRow>
              <StyledTableCell colSpan={totalColumsConsol} align="center">
                Sin registros
              </StyledTableCell>
            </StyledTableRow>
          ) : (
            <StyledTableRow>
            <StyledTableCell align="left">
              <Skeleton />
            </StyledTableCell>
            <StyledTableCell align="left">
              <Skeleton />
            </StyledTableCell>
            <StyledTableCell align="left">
              <Skeleton />
            </StyledTableCell>
            <StyledTableCell align="left">
              <Skeleton />
            </StyledTableCell>
            <StyledTableCell align="left">
              <Skeleton />
            </StyledTableCell>
            <StyledTableCell align="left">
              <Skeleton />
            </StyledTableCell>
            <StyledTableCell align="left">
              <Skeleton />
            </StyledTableCell>
            <StyledTableCell align="left">
              <Skeleton />
            </StyledTableCell>
            <StyledTableCell align="left">
              <Skeleton />
            </StyledTableCell>
          </StyledTableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
